import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
import { localizationStoreInstance } from '../store/localization.store'

export const dayJsInstance = dayjs

dayJsInstance.locale(localizationStoreInstance.locale)
dayJsInstance.extend(relativeTime)
